import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { UserActivitiesParams, UserActivitityResponse } from '@admin/organization/activities/types'
import { getUserActivities } from '@global/api/user-activities'

const THREE_MINUTES = 180_000

const buildQueryKey = (params: UserActivitiesParams) => ['user-activities', 'pagination', params]

export const useUserActivtities = (
  params: UserActivitiesParams,
  options: UseQueryOptions<UserActivitityResponse> = {},
) =>
  useQuery({
    queryKey: buildQueryKey(params),
    queryFn: ({ signal }) => getUserActivities(params, signal),
    staleTime: THREE_MINUTES,
    refetchOnWindowFocus: false,
    ...options,
  })
